import React, {useState} from "react";
import {BillingAccountType} from "@/common/dto/TransAccount";
import {accountTypeNames} from "@/constatants";
import {FtDialog} from "@/common/FtDialog";
import {InputWrap} from "@/component/input/InputWrap";
import {StringInput} from "@/component/input/StringInput";
import {FtSelect} from "@/component/input/FtSelect";
import {AmountInput} from "@/component/input/AmountInput";
import {FtSwitch} from "@/component/input/FtSwitch";
import {FtButton} from "@/common/FtButton";
import {useAccountStore} from "@/store/useAccountStore";
import {AccountData} from "@/common/req/AccountData";
import {ErrorUtil} from "@/utils/ErrorUtil";

interface Props {
    handleClose: () => void;
}

export function AddAccountDialog(props: Props) {
    const [data, setData] = useState<AccountData>({
        name: '',
        type: 'BANK',
        startAmount: 0,
        detail: '',
        archived: false,
    });
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);
    const createAccount = useAccountStore(state => state.createAccount);

    const handleSubmit = async () => {
        setLoading(true);
        setError(null);

        try {
            await createAccount(data);
            props.handleClose();
        } catch (err) {
            setError(ErrorUtil.getErrorMessage(err));
        }

        setLoading(false);
    };

    return (
        <FtDialog handleClose={props.handleClose} title="계정 생성">
            {error && (
                <div style={{margin: "8px 0", padding: "8px", color: "red"}}>
                    Error: {error}
                </div>
            )}

            <InputWrap label="계정 이름">
                <StringInput
                    fullWidth
                    placeholder="계정 이름"
                    value={data.name}
                    onChange={v => setData({...data, name: v})}
                />
            </InputWrap>

            <InputWrap label="계정 유형">
                <FtSelect
                    width="100%"
                    value={data.type}
                    values={Object.keys(accountTypeNames)}
                    labels={Object.values(accountTypeNames)}
                    onChange={v => setData({...data, type: v as BillingAccountType})}
                />
            </InputWrap>

            <InputWrap label="시작 금액">
                <AmountInput
                    value={data.startAmount}
                    fullWidth
                    onChange={v => setData({...data, startAmount: v})}
                />
            </InputWrap>

            <InputWrap label="상세 설명">
                <StringInput
                    fullWidth
                    placeholder="상세 설명"
                    value={data.detail}
                    onChange={v => setData({...data, detail: v})}
                />
            </InputWrap>

            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8, marginBottom: 16}}>
                <div>
                    <FtButton
                        onClick={handleSubmit}
                        variant="contained"
                        style={{minWidth: 80}}
                        disabled={loading}
                    >
                        {loading ? "생성 중..." : "생성"}
                    </FtButton>
                </div>
            </div>

        </FtDialog>
    );
}
